import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {
  sendOtp,
  verifyOtp,
  completeSignup,
  login,
} from "../services/authService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LoginModal = ({
  show,
  handleClose,
  openSignupModal,
  closeLoginModal,
}) => {
  const navigate = useNavigate();
  const [isOtpLogin, setIsOtpLogin] = useState(true);

  // OTP login (email based)
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [existingUserName, setExistingUserName] = useState("");
  const [phoneError, setPhoneError] = useState("");

  // Email/Phone & Password login
  const [loginCredential, setLoginCredential] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      await sendOtp(email);
      toast.success("OTP sent!");
      setOtpSent(true);
    } catch (err) {
      toast.error("Failed to send OTP.");
    }
  };

  const handleVerifyOtp = async (e, code = otp) => {
    if (e) e.preventDefault();
    try {
      const res = await verifyOtp(email, code);
      const data = res.data;

      if (data.isNewUser) {
        setIsNewUser(true);
        toast.info("Please complete registration.");
        setExistingUserName("");
      } else {
        setIsNewUser(false);
        setExistingUserName(data.name);
        localStorage.setItem("user", JSON.stringify(data.user));
        toast.success(`Welcome back, ${data.name}!`);
        handleClose();
      }
    } catch (err) {
      toast.error("Invalid OTP.");
    }
  };

  const handleCompleteSignup = async (e) => {
    e.preventDefault();
    // Validate 10-digit phone number before submit
    if (!/^\d{10}$/.test(phone)) {
      setPhoneError("Please enter a valid 10-digit phone number");
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }
    try {
      await completeSignup({ email, name, phone: "+91" + phone });
      toast.success("Signup complete. Logged in!");
      handleClose();
    } catch (err) {
      toast.error("Signup failed.");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(loginCredential, loginPassword);
      toast.success("Login successful!");
      handleClose();
    } catch (err) {
      toast.error("Login failed. Check credentials.");
    }
  };

  const handleToggle = () => {
    setIsOtpLogin(!isOtpLogin);
    setEmail("");
    setOtp("");
    setOtpSent(false);
    setIsNewUser(false);
    setName("");
    setExistingUserName("");
    setLoginCredential("");
    setLoginPassword("");
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center fw-bold">
          {isOtpLogin ? "Login with Email OTP" : "Login with Email or Phone"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4">
        {/* 
        <div className="text-center mb-3">
          <Button variant="outline-secondary" onClick={handleToggle}>
            {isOtpLogin ? "Use Email/Phone & Password" : "Use Email OTP"}
          </Button>
        </div>
          */}
        {isOtpLogin ? (
          <Form
            onSubmit={
              isNewUser
                ? handleCompleteSignup
                : otpSent
                ? handleVerifyOtp
                : handleSendOtp
            }
          >
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your Email for OTP"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={otpSent || isNewUser}
              />
            </Form.Group>

            {otpSent && !isNewUser && (
              <Form.Group controlId="otp" className="mb-3">
                <Form.Label>Enter OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="6-digit OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </Form.Group>
            )}

            {isNewUser && (
              <>
                <Form.Group controlId="name" className="mb-3">
                  <Form.Label>
                    Your Name <span style={{ color: "red" }}>*</span>
                  </Form.Label>{" "}
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="phone" className="mb-3">
                  <Form.Label>
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </Form.Label>{" "}
                  <Form.Control
                    type="tel"
                    placeholder="Enter 10-digit phone number"
                    value={phone}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,10}$/.test(val)) setPhone(val);
                      if (phoneError) setPhoneError("");
                    }}
                    onBlur={() => {
                      if (phone && !/^\d{10}$/.test(phone)) {
                        setPhoneError("Please enter a valid 10-digit phone number");
                      }
                    }}
                    isInvalid={!!phone && !/^\d{10}$/.test(phone)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {phoneError || "Phone must be exactly 10 digits"}
                  </Form.Control.Feedback>
                </Form.Group>
              </>
            )}

            {existingUserName && (
              <div className="text-center mb-3">
                <strong>Welcome back, {existingUserName}!</strong>
              </div>
            )}

            <Button
              type="submit"
              className="w-100 my-3"
              style={{ backgroundColor: "#FFA500", borderColor: "#FFA500" }}
            >
              {isNewUser
                ? "COMPLETE SIGNUP"
                : otpSent
                ? "VERIFY OTP"
                : "SEND OTP"}
            </Button>
          </Form>
        ) : (
          <Form onSubmit={handleLogin}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="loginCredential">
                  <Form.Label>Email or Phone</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter email or 10-digit phone"
                    value={loginCredential}
                    onChange={(e) => setLoginCredential(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="loginPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              type="submit"
              className="w-100 my-3"
              style={{ backgroundColor: "#FFA500", borderColor: "#FFA500" }}
            >
              SIGN IN
            </Button>
          </Form>
        )}
      </Modal.Body>
      {/* 
      <div className="px-4 pb-4 text-center">
        <hr />
        <div className="fw-bold">DO NOT HAVE AN ACCOUNT?</div>
        <button
          onClick={() => {
            closeLoginModal();
            openSignupModal();
          }}
          className="btn btn-link text-decoration-none fw-bold"
          style={{ color: "#FFA500" }}
        >
          CREATE AN ACCOUNT
        </button>
      </div>
      */}
    </Modal>
  );
};

export default LoginModal;
